/** Backend identity aliases accepted by workspace detail rows. Never invent an API ID. */
export const WORKSPACE_ROW_IDENTITY_KEYS = Object.freeze([
  "stagedId", "staged_id", "StagedId", "_id", "id",
]);

export function workspaceCompanyId(row) {
  const key = WORKSPACE_ROW_IDENTITY_KEYS.find((candidate) => row?.[candidate]);
  return key ? String(row[key]) : null;
}

export function isCompanyActionEligible(company) {
  return Boolean(company?.stagedId && !company._is_stale && !company._isSyntheticId);
}

export function isWorkspaceRowEligible(row) {
  return Boolean(workspaceCompanyId(row) && !row._is_stale && !row._isSyntheticId);
}
